<template>
  <div>
    <div class="echarts" :style="`height: ${height}; min-height: 360px`" >
      <v-chart :option='options' :resizable="true" theme="infographic"></v-chart>
    </div>
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import PostService from '@/scripts/post_service.js'
import IEcharts from 'vue-echarts-v3/src/full.js'
require ('echarts/theme/infographic')

const _ = require('lodash')

export default {
  name: 'SituationCladeFrequencyTimelineArea',
  components: {
    'v-chart': IEcharts,
  },
  data() {
    return { 
      store: store, 
      options: {},
      show: false,
      plotdata: [],
    }
  },
  props: {
    height: String,
    lineages: Array,
    startDate: String,
    endDate: String
  },
  async mounted() {
    const context = this

    context.plotdata = await PostService.getSituationData({
      plot: 'situationCladeFrequencyTimeline',
      lineages: context.lineages,
      startDate: context.startDate,
      endDate: context.endDate
    })

    this.loadChart()
  },
  methods: {
    loadChart: function() {
      const context = this
      let clades = []
      let legendLabels = []

      const data = _.sortBy(context.plotdata, 'date')
      clades = _.uniq(_.flatten(_.map(context.plotdata, 'variant')))
      clades.sort(); clades.reverse()
      legendLabels = _.cloneDeep(context.lineages)
      const lineageColors = store.theme.colors.pangolin_lineages

      const total = _.map(data, d => { return _.sum(d.count) })
      const series = []

      let gap = 3

      clades.forEach(c => {
        const cladeData = []
        let totalCladeCount = 0
        data.forEach((d, i) => { 
          let cladeCount = 0;
          let total = 0;
          for (let j in d.variant) {
            total += parseInt(d.count[j])
            if (d.variant[j] === c) { cladeCount = parseInt(d.count[j]) }
          }
          totalCladeCount += cladeCount

          let [ weekLimitStart, weekLimitEnd ] = store.methods.windowDates(d.date, gap)
          let wCladeCount = 0
          let wTotal = 0
          for (let w=-1*gap; w<=gap; w++) {
            let j = i + w
            if ( j >= 0 && j < data.length) {
              const wdate = data[j].date
              if (wdate >= weekLimitStart && wdate <= weekLimitEnd) {
                for (let k in data[j].variant) {
                  wTotal += parseInt(data[j].count[k])
                  if (data[j].variant[k] === c) {
                    wCladeCount += parseInt(data[j].count[k])
                  }
                }
              }
            }
          }
          cladeData.push([d.date, (wCladeCount/wTotal)*100, wCladeCount])
        })
        series.push({
          data: cladeData, type: 'line', stack: 'all',
          areaStyle: { opacity: 1 },
          itemStyle: { color: lineageColors[c] },
          color: lineageColors[c],
          name: c, symbol: 'none'
        })
      })
      
      context.options = {
        grid: [{left: 50, right: 15, bottom: 35, top: 45}],
        textStyle: { 
          fontFamily: store.theme.fontFamily.content, fontSize: 14
        },
        tooltip: { 
          show: true, trigger: 'axis', axisPointer: { type: 'line' }, 
          position: function (point, params, dom, rect, size) {
            const top= (size.viewSize[1] - size.contentSize[1])/2
            return [point[0], top];
          }, confine: true,
          formatter: function(series) {
            const date = series[0].data[0]
            let content = ''
            let total = 0
            series.reverse()
            series.forEach( s => {
              content += `<div style="display: inline-block; height: 10px; width: 10px; border-radius: 5px; margin-right: 5px; background-color: ${s.color}"></div>`
              total += parseInt(s.data[2])
              content += `<span>${s.seriesName}: ${(s.data[1]).toFixed(2)}% (${s.data[2]})</span>`
              content += '<br>'
            })

            return `${date} (${total})<br>${content}`
          },
          borderColor: '#bebebe', borderWidth: 1,
          backgroundColor: 'rgba(250,250,250,1)',
          textStyle: { color: '#4e4e4e', fontFamily: store.theme.fontFamily.plotTooltip, fontWeight: 'normal' }, padding: 10, 
        },
        legend: { 
          data: legendLabels, left: 10, width: '80%', icon: 'roundRect',
          itemWidth: 15, itemHeight: 15,
          itemStyle: { borderWidth: 1, borderColor: "#9e9e9e"},
          textStyle: { fontSize: 14, fontWeight: 'bold' },
          type: 'scroll'
        },
        xAxis: { type: 'time', 
          axisLabel: { 
            formatter: function(d) {
              const date = new Date(d)
              return `${date.getUTCDate()} ${store.constants.months[parseInt(date.getUTCMonth())]}\n'${date.getUTCFullYear()-2000}`
            },
            // fontSize: 12, color: 'black', fontWeight: 'bold', textAlign: 'right'
          },
        },
        toolbox: {
            show: true,
            feature: {
                magicType: {show: true, type: ['stack', 'tiled']},
                saveAsImage: { show: true, pixelRatio: 5}
            }
        },
        yAxis: {
          min:0, max: 100, axisLabel: {
            formatter: function(d) { return d + '%' },
            // color: 'black', fontWeight: 'bold'  
          },
        },
        series: series, animationDuration: 500,
        animationDurationUpdate: 500, animationDelayUpdate: 200,
        resize: true, animation: true,
      }
    }
  },
}
</script>

<style>
  
</style>